import { ChangeEvent, createRef, MouseEvent, useEffect, useState } from "react";
import { termsValidator } from "../validation.js";
import { trns } from "../helper.js";

import NextButton from "./NextButton.js";
import CheckInput from "./CheckInput.js";
import Markdown from "./Markdown.js";
import withStateSubmit from "./withStateSubmit.js";
import { StringMap, FourthState, FourthStateSubmit, KeyboardEvent } from "../types/types.js";
import { Segment, Item, Heading, Button, Form } from "ui-components";
import useRegStore from "../store/index.js";

type Props = {
  changeState: (field: string, v: string | boolean, setDirty: boolean) => void;
  state: FourthState;
  onSubmit: (e: KeyboardEvent | MouseEvent<HTMLButtonElement>) => Promise<void>;
  reqOrOpt: (field: string) => typeof field;
  isReq: (field: string) => typeof field;
  previousPage: () => void;
  dirty: StringMap<boolean>;
  isFinal: boolean;
  isStart: boolean;
  inFlight: boolean;
  submitted: boolean;

  // Refs
  agree_terms_ref: typeof createRef;
};

const state: FourthState = {
  agree_terms: false,
};

const Fourth = ({
  state,
  onSubmit,
  changeState,
  reqOrOpt,
  isReq,
  dirty,
  submitted,
  inFlight,
  isFinal,
  isStart,
  previousPage,
  agree_terms_ref,
}: Props) => {
  const markdown = useRegStore(state => state.tc_markdown) || "";
  const [checked, setChecked] = useState<boolean>(state.agree_terms);

  useEffect(
    () => {
      if (checked !== state.agree_terms) changeState("agree_terms", checked, true);
    },
    [changeState, checked]
  );

  return (
    <Form className="fieldset">
      <Heading headingLevel="h4">
        {trns("IDS_REGISTRATION_ACCOUNT_INFORMATION", "Account Information")}
      </Heading>

      <Segment className="form-groups">
        {reqOrOpt("agree_terms") && (
          <Segment className="reg-checks">
            <Markdown markdown={markdown} id="MD" className="markdown-group" />
            <CheckInput
              className="field-legal"
              text={trns(
                "IDS_AGREE_TERMS",
                "I certify that I am the minimum legal age for gambling in my jurisdiction, and that I have read and agreed to the Terms & Conditions of this website."
              )}
              value={checked}
              dirty={dirty.agree_terms}
              onInput={(_val: ChangeEvent<HTMLInputElement>, _cb?: Object) => {
                setChecked(_val.target.checked);
              }}
              validator={v => termsValidator(v)}
              req={isReq("agree_terms")}
              ref={agree_terms_ref}
            />
          </Segment>
        )}
      </Segment>

      <Segment className="btn-toolbar reg-nav x">
        <Item className="grid grid-6">
          <Button
            className="btn"
            disabled={isStart}
            onClick={() => {
              !isStart && previousPage();
            }}
          />
        </Item>

        <Item className="grid grid-6">
          <NextButton
            disabled={submitted || inFlight}
            onSubmit={onSubmit}
            isStart={isStart}
            isFinal={isFinal}
          />
        </Item>
      </Segment>
    </Form>
  );
};

export default withStateSubmit(Fourth, state, "step4", (t: FourthStateSubmit) => ({
  agree_terms_ref: (el: typeof createRef) => {
    t.agree_terms_ref = el;
  },
}));
